/** PLUGINS.md §6 — a plugin's permission ids in plain words (shared by the Plugins card + the install dialog). */
/** PURE — a permission id in plain words (the platform's own vocabulary; unknown ids shown as they are). */
export function describePermission(p) {
  const [kind, arg = ''] = String(p || '').split(':', 2);
  if (kind === 'identity.mint') {
    return arg === 'admin' ? "Use this workspace's identity for organization-level work, only in steps a person approved"
      : "Use this workspace's identity to reach your own systems for everyday work";
  }
  if (kind === 'connections') return `Add the “${arg}” connection type`;
  if (kind === 'egress') return `Reach ${arg}`;
  return String(p);
}
